export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-[#1C1C1E] py-24 md:py-36 px-6 md:px-16">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-emerald-400 text-xs font-semibold tracking-[0.2em] uppercase">Reach Out</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold text-white tracking-tight">Get in Touch</h2>
          <p className="mt-4 text-white/50 text-base md:text-lg max-w-lg mx-auto leading-relaxed">
            Have a question or want to learn more about our products? Our team is here to help.
          </p>
          <div className="mt-6 w-14 h-0.5 bg-emerald-500 mx-auto rounded-full" />
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Address Block */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-500/20">
                <i className="ri-map-pin-line text-emerald-400 text-lg" />
              </div>
              <span className="text-white/60 text-xs font-semibold tracking-[0.15em] uppercase">Address</span>
            </div>
            <div className="border-l-2 border-emerald-500 pl-5 space-y-2">
              <p className="text-white text-base font-medium">Markisavska ulica 15</p>
              <p className="text-white/75 text-sm">
                <span className="font-medium text-white/90">City:</span> Murska Sobota
              </p>
              <p className="text-white/75 text-sm">
                <span className="font-medium text-white/90">ZIP:</span> 9000
              </p>
              <p className="text-white/75 text-sm">
                <span className="font-medium text-white/90">Country:</span> Slovenia
              </p>
            </div>
          </div>

          {/* Communication Block */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 flex flex-col gap-8">
            {/* Email */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-500/20">
                  <i className="ri-mail-line text-emerald-400 text-lg" />
                </div>
                <span className="text-white/60 text-xs font-semibold tracking-[0.15em] uppercase">Email</span>
              </div>
              <div className="border-l-2 border-emerald-500 pl-5">
                <p className="text-white text-base font-medium">info@noxdoo.com</p>
                <p className="text-white/50 text-xs mt-1">We respond within 24 hours</p>
              </div>
            </div>

            {/* Phone */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-500/20">
                  <i className="ri-phone-line text-emerald-400 text-lg" />
                </div>
                <span className="text-white/60 text-xs font-semibold tracking-[0.15em] uppercase">Phone</span>
              </div>
              <div className="border-l-2 border-emerald-500 pl-5">
                <p className="text-white text-base font-medium">+1 5186348964</p>
                <p className="text-white/50 text-xs mt-1">Mon–Fri, 9:00 – 17:00 CET</p>
              </div>
            </div>
          </div>
        </div>

        {/* Company Footer Note */}
        <div className="mt-16 pt-10 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/d0159d21-72a5-4d01-bd23-06259d881c81.png"
                alt="NOX Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <span className="text-white/70 text-sm font-medium">NOX, d.o.o.</span>
          </div>
          <p className="text-white/30 text-xs text-center sm:text-right">
            &copy; {new Date().getFullYear()} NOX, d.o.o. All rights reserved. Murska Sobota, Slovenia.
          </p>
        </div>
      </div>
    </section>
  );
}
